import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/gmn'
const QUERY_KEY = 'gmn'

export const useGetGmn = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config,
  )

export const usePostGmn = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const usePatchGmn = (config = {}) =>
  useMutation((updatedData) => API.patch(ENDPOINT, updatedData), config)

export const useDeleteGmn = (config = {}) =>
  useMutation((id) => API.delete(ENDPOINT, { data: id }), config)

export const useGetGmnPoint = ({ customerId, ...query } = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'points', customerId, query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/points/${customerId}`, query))).data,
    config,
  )

export const useGetGmnPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'points', query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/points`, query))).data,
    config,
  )

export const useExportGmnPoints = (config = {}) =>
  useMutation(
    (data) => API.post(`${ENDPOINT}/points/export`, data, { responseType: 'blob' }),
    config,
  )
